module.exports = __webpack_public_path__ + "img/curso-ortografia.5474ae57.png";